import React from 'react';
import Lottie from 'react-lottie';
import animationData from 'assets/animations/loading';

import { Wrapper, Spinner, LoadingText } from './styles';

const LoadingSpinner = () => (
  <Wrapper>
    {/*<LoadingText>Loading...</LoadingText>*/}
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice',
        },
      }}
      isStopped={false}
      isPaused={false}
      height={60}
      width={60}
    />
  </Wrapper>
);

export default LoadingSpinner;
